export { Bloc } from './Bloc';
export { Contents } from './Contents';
export { Title } from './Title';
export { CoverPicture } from './CoverPicture';
